<template>
    <section class="section-bg-image">
        <svg viewBox="0 50 1265 0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <path fill="rgba(255, 255, 255, 1)" d="M 0 40 C 164 40 164 20 328 20 L 328 20 L 328 0 L 0 0 Z"
                stroke-width="0"></path>
            <path fill="rgba(255, 255, 255, 1)" d="M 327 20 C 445.5 20 445.5 89 564 89 L 564 89 L 564 0 L 327 0 Z"
                stroke-width="0"></path>
            <path fill="rgba(255, 255, 255, 1)" d="M 563 89 C 724.5 89 724.5 48 886 48 L 886 48 L 886 0 L 563 0 Z"
                stroke-width="0"></path>
            <path fill="rgba(255, 255, 255, 1)" d="M 885 48 C 1006.5 48 1006.5 67 1128 67 L 1128 67 L 1128 0 L 885 0 Z"
                stroke-width="0"></path>
            <path fill="rgba(255, 255, 255, 1)" d="M 1127 67 C 1196 67 1196 0 1265 0 L 1265 0 L 1265 0 L 1127 0 Z"
                stroke-width="0"></path>
        </svg>

        <div class="container">
            <div class="row">

                <footer class="site-footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-3 col-12 me-auto mb-5 mb-lg-0">
                                <a class="navbar-brand d-flex align-items-center" href="javascript:void(0)">
                                    <img src="images/logo.png" style="height: 100px;">
                                    <span class="navbar-brand-text text-black">
                                        SIBERBI
                                        <small style="font-size: small;">SIMULASI BERUSAHA<br></br>BANGUN INVESTASI
                                        </small>
                                    </span>
                                </a>
                            </div>
                            <div class="col-lg-3 col-12 me-auto mb-5 mb-lg-0">
                                <h5 class="site-footer-title mb-4 text-black">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Jumlah Pengunjung</span>
                                    <span v-else>Number of visitors</span>
                                </h5>
                                <a href="#" class="text-black">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Hari ini: {{ G_numFormat(harini)
                                    }}</span>
                                    <span v-else>Today: {{ G_numFormat(harini) }}</span>
                                </a><br>
                                <a href="#" class="text-black">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Bulan ini: {{
                                        G_numFormat(bulanini)
                                    }}</span>
                                    <span v-else>This month: {{ G_numFormat(bulanini) }}</span>
                                </a><br>
                                <a href="#" class="text-black">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Tahun ini: {{
                                        G_numFormat(tahunini)
                                    }}</span>
                                    <span v-else>This year: {{ G_numFormat(tahunini) }}</span>
                                </a>
                                <br>
                                <a href="#" class="text-black">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Total Pengunjung: {{
                                        G_numFormat(totalpengunjung) }}</span>
                                    <span v-else>Total visitor: {{ G_numFormat(totalpengunjung) }}</span>
                                </a>

                            </div>
                            <div class="col-lg-3 col-12 me-auto mb-5 mb-lg-0">
                                <div class="footer-item d-flex flex-column">
                                    <h5 class="site-footer-title mb-4 text-black">
                                        <span v-if="(bahasa === null) || (bahasa == 'ina')">Tautan Terkait</span>
                                        <span v-else>Related Links</span>
                                    </h5>
                                    <a href="https://semarangkota.go.id/" class="text-black" target="_blank"><i
                                            class="fas fa-angle-right me-2"></i>
                                        Pemerintah Kota Semarang</a>
                                    <a href="https://izin.semarangkota.go.id/portal" class="text-black" target="_blank"><i
                                            class="fas fa-angle-right me-2"></i>
                                        DPMPTSP Kota Semarang</a>
                                </div>
                            </div>
                            <div class="col-lg-3 col-12 ms-auto">
                                <h5 class="site-footer-title mb-4 text-black">
                                    <span v-if="(bahasa === null) || (bahasa == 'ina')">Info Kontak</span>
                                    <span v-else>Contact Info</span>
                                </h5>
                                <a href="" class="text-black"><i class="fa fa-map-marker-alt me-2"></i> Dinas Penanaman
                                    Modal Pelayanan Terpadu Satu Pintu Kota Semarang
                                    Terminal Mangkang Lantai 2</a>
                                <ul class="social-icon">
                                    <li class="social-icon-item">
                                        <a href="https://www.instagram.com/dpmptsp_kotasemarang/?hl=id" target="_blank"
                                            class="social-icon-link bi-instagram"></a>
                                    </li>
                                    <li class="social-icon-item">
                                        <a href="https://x.com/dpmptspsemarang/with_replies" target="_blank"
                                            class="social-icon-link bi-twitter"></a>
                                    </li>
                                    <li class="social-icon-item">
                                        <a href="https://www.youtube.com/channel/UCCnSMsD5-XCD7PGF21cSzig"
                                            target="_blank" class="social-icon-link bi-youtube"></a>
                                    </li>
                                    <li class="social-icon-item">
                                        <a href="https://web.facebook.com/p/Dinas-Penanaman-Modal-dan-Pelayanan-Terpadu-Satu-Pintu-100063491973727/?locale=id_ID&_rdc=1&_rdr#"
                                            target="_blank" class="social-icon-link bi-facebook"></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </footer>

            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';
import swal from 'sweetalert2';

export default {
    components: {
        swal
    },
    data() {
        return {
            tahun: new Date().getFullYear(),
            bahasa: localStorage.getItem("bahasasistem"),
            datapesan: '',
            harini: 0,
            bulanini: 0,
            tahunini: 0,
            totalpengunjung: 0,
            project_id: process.env.VUE_APP_PROJECT_ID,
        };
    },
    methods: {
        async ambildata() {
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer PMC2024Q06S0rZXcJyEH3wk8jVrINbHwn7tBq2",
                },
            });
            var random = Math.random();
            await mainAPI.get("parastapainnovationVisitor-GetVisitor?random=" + random + "&project_id=" + this.project_id).then(
                Response => {
                    this.datapesan = Response.data.message;
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.harini = Response.data.hariini;
                        this.bulanini = Response.data.bulanini;
                        this.tahunini = Response.data.tahunini;
                        this.totalpengunjung = Response.data.total;
                    }
                    this.halamanloading = false;
                }
            ).catch(error => {
                this.datapesan = [];
                //console.log(error);
            });
        },
    },
    mounted() {
        this.ambildata();
    },
}
</script>

<style></style>